type ConsentListener = (hasConsent: boolean) => void;

function hasOneTrust(): boolean {
    return typeof window.OnetrustActiveGroups === 'string';
}

function hasCookiebot(): boolean {
    return typeof window.Cookiebot?.consent?.statistics === 'boolean';
}

/** OneTrust performance/analytics group (adjust if your banner uses another ID). */
const ONETRUST_ANALYTICS_GROUP = 'C0002';

export function hasAnalyticsCookieConsent(): boolean {
    if (hasOneTrust()) {
        return window.OnetrustActiveGroups!.includes(ONETRUST_ANALYTICS_GROUP);
    }
    if (hasCookiebot()) {
        return Boolean(window.Cookiebot!.consent.statistics);
    }
    return true;
}

export function isCookieConsentToolPresent(): boolean {
    return hasOneTrust() || hasCookiebot();
}

export function subscribeToCookieConsentChanges(listener: ConsentListener): () => void {
    const notify = () => listener(hasAnalyticsCookieConsent());

    notify();

    if (hasCookiebot()) {
        const onAccept = () => notify();
        const onDecline = () => notify();
        window.addEventListener('CookiebotOnAccept', onAccept);
        window.addEventListener('CookiebotOnDecline', onDecline);
        return () => {
            window.removeEventListener('CookiebotOnAccept', onAccept);
            window.removeEventListener('CookiebotOnDecline', onDecline);
        };
    }

    if (hasOneTrust()) {
        const previousWrapper = window.OptanonWrapper;
        window.OptanonWrapper = () => {
            previousWrapper?.();
            notify();
        };
        return () => {
            if (window.OptanonWrapper) {
                window.OptanonWrapper = previousWrapper;
            }
        };
    }

    return () => undefined;
}
